import { FC } from 'react';
import styled from 'styled-components';
import { Button, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

export type PurchaseSeatMode = 'NO_AVAILABLE_SEATS' | 'ADD_NEW_SEAT';

type NeedDefaultPaymentMethodModalProps = {
  open: boolean;
  brandId: string;
  onClose: () => void;
  onGoToBillingTab: () => void;
};

export const NeedDefaultPaymentMethodModal: FC<NeedDefaultPaymentMethodModalProps> = ({
  open,
  brandId,
  onClose,
  onGoToBillingTab,
}) => {
  const style = {
    position: 'absolute',
    top: '50%',
    left: '42%',
    transform: 'translate(-50%, -50%)',
    width: 480,
    bgcolor: '#333',
    border: '2px solid #333',
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ color: '#fff', marginBottom: 4, textAlign: 'center' }}
        >Need Default Payment Method</Typography>
        <MessageLabel id="modal-modal-description" sx={{ mt: 2 }}>
          You need to add a default payment method to your account before you can purchase a seat.
        </MessageLabel>
        <StyledButtonContainer>
          <StyledCancelButton onClick={onClose}>CANCEL</StyledCancelButton>
          <StyledPurchaseButton
            variant={'contained'}
            onClick={onGoToBillingTab}
          >
            GO TO BILLING TAB
          </StyledPurchaseButton>
        </StyledButtonContainer>
      </Box>
    </Modal >
  );
};

const MessageLabel = styled(Typography)({
  fontSize: 16,
  fontWeight: 400,
  marginBottom: '4px',
  color: '#fff',
});

const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledCancelButton = styled(Button)({
  textTransform: 'none',
  width: '200px',
  height: '48px',
  fontSize: 16,
  marginTop: 24,
  marginRight: 16,
});

const StyledPurchaseButton = styled(Button)({
  textTransform: 'none',
  width: '200px',
  height: '48px',
  fontSize: 16,
  marginTop: 24,
});
